import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgFilterIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M20 4H4l6.222 7.53v6.588L13.778 20v-8.47L20 4Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 7H17"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgFilterIcon);
const Memo = memo(ForwardRef);
export default Memo;
